import type { FaireProductEntity } from "../../entity_types/product";

export const p_v2vnhbjgup: FaireProductEntity = {
  token: "p_v2vnhbjgup",
  type: "product",
  name: "PREMIUM POSTCARDS Hawaiian Islands, Typography & Icons 2",
  brandName: "Lantern Press",
  imageUrl:
    "https://cdn.faire.com/fastly/c2c1c334d0f6c2d711c28af946e0233c0d98c840bc5c2e6263f291f8aaa0f574.jpeg",
  priceDollars: 0.4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ba45914bf04dcdf4924a09a7191f87bbcb2b0ae4df0ec10f2268707253f62ca7.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
